
import { getAlsoPurchasedProductsCollectionV2, getProductCollectionV2, getRelatedProductsCollectionV2 } from "@dana/Overrides/Services/ProductServiceV2";
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    RequestDataFromApi,
    async props => {
        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const { storefrontAccess } = getSettingsCollection(state).productSettings;
        if (
            storefrontAccess === StorefrontAccess.SignInRequiredToBrowse &&
            !state.context.session.isAuthenticated &&
            (currentPage.fields.excludeFromSignInRequired || currentPage.type === "SignInPage")
        ) {
            return false;
        }

        try {
            if ("relationship" in props.apiParameter) {
                props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
            } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
                props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
            } else {
                props.apiResult = await getProductCollectionV2(props.apiParameter);
            }
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.parameter.onError?.(error.errorJson.message);
                return false;
            }

            if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
                // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
                error.status = 401;
                error.errorJson = { message: "error" };
            }

            throw error;
        }

    },
);
